import CompanyDataForm from '../../compositions/Subscription/Forms/CompanyDataForm'
import React, { useCallback, useEffect, useState } from 'react'
import { Company, Login } from '../../types/Subscription'
import { useAdmin } from '../../contexts/AdminContext'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Button from '../../components/Button'
import { useTranslation } from 'react-i18next'
import { showToast } from '../../services/ToastService'
import { useNavigate } from 'react-router-dom'

const SubscriptionCompanyChange: React.FC = () => {
    const { user, service, getUser } = useAdmin()
    const [company, setCompany] = useState<Partial<Company>>({})
    const navigate = useNavigate()
    const { t } = useTranslation(['settings'])
    const changeData = useCallback((data: Partial<Company & Login>) => {
        setCompany((prevElement) => ({ ...prevElement, ...data }))
    }, [])

    useEffect(() => {
        if (user) {
            const { email, agb, disclaimer, ...rest } = user
            setCompany(rest)
        }
    }, [user])

    const submit = () => {
        service.updateUser(company).then((res) => {
            if (res.status === 200) {
                if (res.data?.data) {
                    getUser()
                    navigate('/subscription')
                }
                showToast(t('subscription.companyDataUpdatedSuccessfully'))
            } else {
                showToast(t('subscription.errorUpdatingCompanyData'), 'error')
            }
        })
    }

    return (
        <div className={'zr-mt-3'}>
            <Heading level={3} classes={'zr-mb-4'}>
                {t('subscription.adjustCompanyData')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/subscription')}
            >
                {t('subscription.back')}
            </IconButton>
            <CompanyDataForm
                data={company}
                changeData={changeData}
                showAGBandDisclaimer={false}
            />
            <div className={'zr-m-4 zr-d-flex zr-justify-end'}>
                <Button
                    fn={() => submit()}
                    hierarchy={'primary'}
                    text={t('subscription.applyChanges')}
                />
            </div>
        </div>
    )
}

export default SubscriptionCompanyChange
